import React from "react";

export interface LegendItem {
  label: string;
  color: string;
  percentage: string;
}

interface ChartLegendProps {
  items: LegendItem[];
  onClick?: (itemIndex: number) => void;
}

export const ChartLegend: React.FC<ChartLegendProps> = ({ items, onClick }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {items.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: onClick ? "pointer" : "default",
          }}
          onClick={() => onClick?.(index)}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "3px",
                backgroundColor: item.color,
              }}
            />
            <span style={{ fontSize: "14px", color: "#595959" }}>
              {item.label}
            </span>
          </div>
          <span style={{ fontSize: "15px", fontWeight: 600, color: "#262626" }}>
            {item.percentage}%
          </span>
        </div>
      ))}
    </div>
  );
};
